const styleComponentAlert = {
  alertContainer: {
    width: "25%",
    height: "auto",
    padding: 7,
    borderRadius: 15,
    position: "absolute",
    bottom: "4.5%",
    left: "2%",
    zIndex: 5
  },
};

export { styleComponentAlert };
